import type { ProjectOverview } from "@/api/hooks";

/** Server duration, anchored to local receipt: client/server clock skew cancels. */
export function journeyDeadline(
  journey: ProjectOverview["journey"] | undefined,
  receivedAt: number,
): number {
  if (!journey || !Number.isFinite(receivedAt) || receivedAt <= 0) return 0;
  const lifetime = Date.parse(journey.refreshAfter) - Date.parse(journey.asOf);
  if (!Number.isFinite(lifetime) || lifetime <= 0 || lifetime > 60_000)
    return 0;
  return receivedAt + lifetime;
}

/** True once the local clock passes the receipt-anchored deadline, or when none can be derived. */
export function journeyExpired(
  journey: ProjectOverview["journey"] | undefined,
  receivedAt: number,
): boolean {
  return Date.now() >= journeyDeadline(journey, receivedAt);
}
